export type { TolgeeConfig } from './config';
export { getTolgeeConfig } from './config';
export { createTolgeeInstance, resetTolgeeInstance } from './factory';
